import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import { useStyles } from "./PromoteStudents.css";
import AdminHeader from "../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import StudentFormFilter from "./StudentFormFilter/StudentFormFilter";
import CustomTableHead from "../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomEmptyMessage from "../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../Components/CustomSiteLoader/CustomSiteLoader";
import PromoteStudentBody from "./PromoteStudentBody/PromoteStudentBody";
import CustomTableFooter from "../../../Components/Table/CutomTableFooter/CustomTableFooter";
import Axios from "axios";
import { url } from "../../../Config/Config";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class PromoteStudents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 20,
      page: 0,
      from: {
        session: new Date().getFullYear().toString(),
        studentClass: "",
        faculty: "",
        group: "",
        section: "",
      },
      to: {
        session: (new Date().getFullYear() + 1).toString(),
        studentClass: "",
        faculty: "",
        group: "",
        section: "",
      },
      column: [
        { name: "S.N." },
        { name: "Student Name" },
        { name: "Class" },
        { name: "Faculty" },
        { name: "Group" },
        { name: "Section" },
      ],
      studentList: [],
      isEmpty: false,
      detailStatus: false,
      studentFeeId: "",
      detailData: {},
      students: [],
      studentListError: "",
      notificationOpen: false,
    };
  }

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleFromChange = (e) => {
    this.setState({
      from: {
        ...this.state.from,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleToChange = (e) => {
    this.setState({
      to: {
        ...this.state.to,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubmit = (e, students) => {
    e.preventDefault();
    if (students.length === 0) {
      this.setState({
        isEmpty: true,
      });
    } else {
      this.setState({
        studentList: students,
        isEmpty: false,
      });
    }
  };

  handleSelectAllClick = (e) => {
    if (e.target.checked) {
      const newSelected = this.state.studentList.map((data) => data._id);
      this.setState({
        students: newSelected,
      });
      return;
    }
    this.setState({
      students: [],
    });
  };

  handleClick = (students) => {
    this.setState({
      students,
    });
  };

  filterData = (data) => {
    let changedData = data;
    if (!data.faculty) {
      delete changedData.faculty;
    }

    if (!data.group) {
      delete changedData.group;
    }

    return changedData;
  };

  checkError = () => {
    let studentListError = "";
    if (this.state.students.length === 0) {
      studentListError = "At least one student needs to be listed";
    }

    if (studentListError) {
      this.setState({ studentListError });
      return true;
    } else {
      this.setState({ studentListError: "" });
      return false;
    }
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  handlePromote = async () => {
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        let changedData = this.filterData(this.state.to);
        let data = { students: this.state.students, ...changedData };
        const response = await Axios.put(`${url}/api/students/promote`, data, {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        });
        if (response.data.message === "Promoted successfully") {
          this.handleNotificationOpen();
          this.getStudents();
        }
      } catch (error) {
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handlePromote();
        }
      }
    }
  };
  getStudents = async () => {
    try {
      const studentResponse = await Axios.get(`${url}/api/students`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      let studentList = [];
      if (studentResponse.data.students.length !== 0) {
        studentList = studentResponse.data.students.filter((filter) => {
          return this.state.from.faculty && this.state.from.group
            ? filter.currentSession.indexOf(this.state.from.session) !== -1 &&
                filter.studentClass.indexOf(this.state.from.studentClass) !==
                  -1 &&
                filter.faculty.indexOf(this.state.from.faculty) !== -1 &&
                filter.group.indexOf(this.state.from.group) !== -1 &&
                filter.section.indexOf(this.state.from.section) !== -1
            : filter.currentSession.indexOf(this.state.from.session) !== -1 &&
                filter.studentClass.indexOf(this.state.from.studentClass) !==
                  -1 &&
                filter.section.indexOf(this.state.from.section) !== -1;
        });
      }
      if (studentList.length !== 0) {
        this.setState({
          studentList: studentList,
          isEmpty: false,
        });
      } else {
        this.setState({
          studentList: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStudents();
      }
    }
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="success"
          elevation={6}
          variant="filled"
        >
          Promoted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Promote Student" />
          <StudentFormFilter
            studentList={true}
            buttonLabel="Get Students"
            data={this.state.from}
            handleChange={this.handleFromChange}
            handleSubmit={this.handleSubmit}
          />
          {this.state.studentList.length !== 0 ? (
            <div>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>Promote To</div>
              <StudentFormFilter
                buttonLabel="Promote"
                studentList={false}
                data={this.state.to}
                handleChange={this.handleToChange}
                handleSubmit={this.handlePromote}
              />
              {this.state.studentListError && (
                <div style={{ color: "red" }}>
                  {this.state.studentListError}
                </div>
              )}
              <TableContainer>
                <Table>
                  <CustomTableHead
                    column={this.state.column}
                    showCheckbox={true}
                    numSelected={this.state.students.length}
                    onSelectAllClick={this.handleSelectAllClick}
                    rowCount={this.state.studentList.length}
                  />

                  <TableBody>
                    {(rowsPerPage > 0
                      ? this.state.studentList.slice(
                          rowsPerPage * page,
                          rowsPerPage * page + rowsPerPage
                        )
                      : this.state.studentList
                    ).map((student, index) => (
                      <PromoteStudentBody
                        key={index}
                        index={index}
                        data={student}
                        handleClick={this.handleClick}
                        students={this.state.students}
                      />
                    ))}
                  </TableBody>
                  <CustomTableFooter
                    count={this.state.studentList.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
              </TableContainer>
              {this.showNotification()}
            </div>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage description="Student List is not present in the database of this class" />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(PromoteStudents));
